import { pieceTypes } from "../../../../constants";

const pieceTypeOptions = Object.entries(pieceTypes).map(([key, value]) => ({
  label: key,
  value: value.value,
}));

function PieceTypeCell({ value }) {
  const pieceType = pieceTypeOptions.find(
    (option) => option.value === value,
  ) || { label: "Unknown", value };

  return <div>{pieceType.label}</div>;
}

export default PieceTypeCell;
